import { Box } from '@mui/material';
import { CSSProperties, FunctionComponent, PropsWithChildren } from 'react';

export interface Props extends PropsWithChildren {
  height?: CSSProperties['height'];
}

export const Card: FunctionComponent<Props> = ({ children, height }) => {
  return <Box
    sx={{
      background: '#F6F8F9',
      p: 2,
      borderRadius: '0.75rem',
      zIndex: 401,
      position: 'relative',
      height: height ?? '100%',
    }}
  >
    {children}
  </Box>;
};
